/**
 * (Группа 6) Пользователи и RBAC + impersonation.
 *
 * Реальные данные частично есть (admin roles API):
 *   - REAL GET/POST .../admin/roles, .../admin/users/{id}/roles|permissions
 * Глобальный cross-tenant поиск пользователей и step-up impersonation —
 * TODO backend (endpoint /v1/admin/impersonation отсутствует).
 */
import { PageStub } from '../../shared/PageStub.js';

export function RbacPage(): JSX.Element {
  return (
    <PageStub
      testId="rbac-page"
      title="Пользователи и RBAC"
      description="Cross-tenant поиск пользователей, назначение/отзыв ролей, пресеты команды, impersonation."
      sections={[
        'Глобальный поиск пользователей по имени/email/отелю',
        'Карточка пользователя: роли, сброс пароля, журнал активности',
        'Назначение роли (отель, роль, срок, причина)',
        'Отзыв роли (причина, предупреждение о завершении сессий)',
        'Матрица пресетов команды: root / support / finance / readonly',
        'Step-up impersonation: повторный 2FA + причина ≥20 символов, TTL 15 мин',
        'Баннер активной impersonation с обратным отсчётом',
      ]}
      dataSource="REAL admin roles/users API; глобальный поиск и impersonation — TODO backend (/v1/admin/impersonation)"
    />
  );
}
